import axios from 'axios';

const featureflagAPI = {
	getFeatureFlag: async (request: GetFeatureFlagRequest) => {
		const response = await axios.get(`/featureflag/${request.name}`);
		return response.data as boolean;
	}
};

export default featureflagAPI;